import PropTypes from 'prop-types';
import './FormField.css';

/**
 * Enhanced Form Field component with better styling and validation
 */
export default function FormField({
  label,
  id,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  error,
  helperText,
  className = '',
  children,
  ...props
}) {
  const fieldId = id || name;
  const hasError = !!error;

  return (
    <div className={`form-field ${hasError ? 'form-field-error' : ''} ${className}`.trim()}>
      {label && (
        <label htmlFor={fieldId} className="form-field-label">
          {label}
          {required && <span className="form-field-required">*</span>}
        </label>
      )}
      <div className="form-field-input-wrapper">
        {children || (
          <input
            id={fieldId}
            name={name}
            type={type}
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            className={`form-field-input ${hasError ? 'form-field-input-error' : ''}`.trim()}
            aria-invalid={hasError}
            aria-describedby={
              hasError
                ? `${fieldId}-error`
                : helperText
                ? `${fieldId}-helper`
                : undefined
            }
            {...props}
          />
        )}
      </div>
      {error && (
        <div id={`${fieldId}-error`} className="form-field-error-message" role="alert">
          {error}
        </div>
      )}
      {helperText && !error && (
        <div id={`${fieldId}-helper`} className="form-field-helper-text">
          {helperText}
        </div>
      )}
    </div>
  );
}

FormField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  helperText: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

